import { render, staticRenderFns } from "./ActivetyLiveRoom.vue?vue&type=template&id=226505e8&scoped=true"
import script from "./ActivetyLiveRoom.vue?vue&type=script&lang=js"
export * from "./ActivetyLiveRoom.vue?vue&type=script&lang=js"
import style0 from "./ActivetyLiveRoom.vue?vue&type=style&index=0&id=226505e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226505e8",
  null
  
)

export default component.exports